import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import { loadLocaleMessages } from '@/utils';
// import JSONLocalStorage from '@/utils/local-storage';

Vue.use(VueI18n);

// console.log(ElementLocale, 'ElementLocale');

export default {
  // 初始化语言
  initLang({ state, commit }, lang) {
    return new Promise(resolve => {
      lang = lang || state.language;
      const i18n = new VueI18n({
        locale: lang,
        fallbackLocale: 'zh-CN',
        messages: loadLocaleMessages()
      });
      // JSONLocalStorage.setItem('userLang', lang);
      localStorage && localStorage.setItem('userLang', lang);
      commit('SET_LANG', lang);
      ElementLocale.i18n((key, value) => i18n.t(key, value));
      resolve(i18n);
    });
  },
  updateLang({ commit }, { i18n, lang }) {
    return new Promise((resolve) => {
      // JSONLocalStorage.setItem('userLang', lang);
      localStorage && localStorage.setItem('userLang', lang);
      commit('SET_LANG', lang);
      i18n.locale = lang;
      resolve();
    });
  }
};
